import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import Links from '@/shared/constants/navegacao';
import Loading from '@/shared/components/Carregando';
import MyContext from '@/shared/contexts/AppContext';
import { Deslogar } from '@/modules/system/auth/application/auth.service';
import { initialState } from '@/shared/contexts/AppProvider';

export default function LogoutPage() {
  const navigate = useNavigate();
  const context = useContext(MyContext);

  if (!context)
    throw new Error('DisplayComponent deve ser usado dentro de um MyProvider');
  const { setState } = context;

  useEffect(() => {
    setState(initialState);
    
    setTimeout(() => {
      Deslogar();
      navigate(`${Links.Auth_Login}`);
    }, 1000);
  }, [setState, navigate]);

  return (
    <>
      <span>Saindo... aguarde...</span>
      <Loading />
    </>
  );
}
